import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';

var genFooterToolBarStyle = function genFooterToolBarStyle(token) {
  return _defineProperty({}, token.componentCls, {
    position: 'fixed',
    insetInlineEnd: 0,
    bottom: 0,
    zIndex: 99,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingInline: 24,
    paddingBlock: 0,
    boxSizing: 'border-box',
    lineHeight: '64px',

    /* A way to reset the style of the component. */
    backgroundColor: 'rgba(255, 255, 255, 0.58)',
    borderBlockStart: "1px solid ".concat(token.colorSplit),
    '-webkit-backdrop-filter': 'blur(8px)',
    backdropFilter: 'blur(8px)',
    transition: 'all 0.2s ease 0s',
    '&-left': {
      flex: 1
    },
    '&-right': {
      '> *': {
        marginInlineEnd: 8,
        '&:last-child': {
          marginBlock: 0,
          marginInline: 0
        }
      }
    }
  });
};

export function useStyle(prefixCls) {
  return useAntdStyle('footer-toolbar', function (token) {
    var proCardToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });

    return [genFooterToolBarStyle(proCardToken)];
  });
}